import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaCodificacionOrdenPago from "./tablaCodificacionOrdenPago";
import CatalogoCompromisosUbicacion from "../../catalogos/catalogoCompromisosUbicacion";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";
import TablaFacturas from "./tablaFactura.js";
import TablaRetenOrdenPago from "./tablaRetencionOrdenPago";
import TablaRetenISLR from "./tablaRetenISLR";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import ValidarUsuario from "../comun/modalValidarUsuario";
import { CambiodeDatos } from "../comun/modalCambiodDatos";
import { numeroaLetra } from "../../util/NumeroaLetra";
import { ModalModificarFact } from "./modalModificarFactura.js";

import {
  Input,
  SearchInput,
  Select,
  Textarea,
} from "../../ui/inputs/Input.jsx";
import { DangerButton, SuccessButton, WarningButton } from "../../ui/buttons/Button.jsx";

export const ActualizarOrdenPago = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const liquidador = JSON.parse(localStorage.getItem("liquidador"));
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));

  const [tabs, setTabs] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane",
    tab3: "tab-pane",
    tab4: "tab-pane",
  });
  const [mostrar6, setMostrar6] = useState(false);
  const [activate, setActivate] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [habiCod, setHabicod] = useState(true);
  const [habicat, setHabicat] = useState(true);
  const [habicatb, setHabicatb] = useState(true);
  const [habibref, setHabiref] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [datosFac, setDatosFac] = useState([]);
  const [datosRet, setDatosRet] = useState([]);
  const [datosIsrl, setDatosIsrl] = useState([]);
  const [itemSelect, setItemSelect] = useState(-1);
  const [valida, setValida] = useState(0);
  const [tipoComp, setTipoComp] = useState(null);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [data, setData] = useState([]);
  const [dataFac, setDataFac] = useState([]);
  const [dataRet, setDataRet] = useState([]);
  const [dataIsrl, setDataIsrl] = useState([]);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [reteIslr, setReteIslr] = useState(0.0);
  const [totalRetenido, setTotalRetenido] = useState(0.0);
  const [totalFactura, setTotalFactura] = useState(0.0);
  const [totalCausar, setTotalCausar] = useState(0.0);
  const [totalBaseImpo, setTotalBaseImpo] = useState(0.0);
  const [fechaRef, setFechaRef] = useState(null);
  const [fecha, setFecha] = useState(null);
  const [fechaRev, setFechaRev] = useState(null);
  const [llamado, setLlamado] = useState(0);
  const [cambiarDatos, setCambiarDatos] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [natural, setNatural] = useState(false);
  const [tipo, setTipo] = useState(0);
  const [ultimo, setUltimo] = useState(false);
  const [idOrden, setIdOrden] = useState(false);
  const [desde, setDesde] = useState(0);
  const [habiConcep, setHabiConcep] = useState(false);
  const [habiFecha, setHabiFecha] = useState(false);
  const [canReten, setCanReten] = useState(0);
  const [amortizacion, setAmortizacion] = useState(0.0);
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [modifi1, setModifi1] = useState(false);
  const [proce1, setProce1] = useState(false);
  const [proce2, setProce2] = useState(false);
  const btnAcepta = useRef();
  const txtCodigo = useRef();
  const txtIdCompromiso = useRef();
  const txtFechaOP = useRef();
  const txtObservacionOP = useRef();
  const txtFechaCompromiso = useRef();
  const txtFechaReverso = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtIdprov = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtIdCoordinacion = useRef();
  const txtNombreUnidad = useRef();
  const txtTipoCompromiso = useRef();
  const txtReferencia = useRef();
  const txtConcepto = useRef();
  const txtMontoCausar = useRef();
  const txtMontoFondo = useRef();
  const txtCodCuenta = useRef();
  const txtBanco = useRef();
  const txtNumCuentaBanco = useRef();
  const txtAmortizacion = useRef();
  const txtTotalPagar = useRef();

  const blanquearDatosCompromiso = () => {
    txtFechaCompromiso.current.value = "";
    txtTipoCompromiso.current.value = "";
    setHabiref(true);
    txtReferencia.current.value = "";
    txtConcepto.current.value = "";
    txtObservacion.current.value = "";
    txtIdCoordinacion.current.value = "";
    txtNombreUnidad.current.value = "";
    txtIdprov.current.value = "";
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setTotalCausar(0.0);
    txtMontoCausar.current.value = "0,00";
    if (txtMontoFondo && txtMontoFondo.current) {
      txtMontoFondo.current.value = "0,00";
    }
    setDatospre([]);
    setDatosFac([]);
    setDatosRet([]);
    setDatosIsrl([]);
    setTipoComp(null);
  };

  const onChange = (e) => {
    if (
      e.target.name === "descriaux" ||
      e.target.name === "ubicacion" ||
      e.target.name === "observacion"
    ) {
      e.target.value = e.target.value.toUpperCase();
    } else if (e.target.name === "idcompromiso") {
      blanquearDatosCompromiso();
    } else if (e.target.name === "referencia") {
      txtConcepto.current.value = "";
      txtObservacion.current.value = "";
      txtIdprov.current.value = "";
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      setTotalCausar(0.0);
      txtMontoCausar.current.value = "0,00";
      if (txtMontoFondo && txtMontoFondo.current) {
        txtMontoFondo.current.value = "0,00";
      }
      setItemSelect(-1);
      setDatospre([]);
      setDatosFac([]);
      setDataFac([]);
      setDatosRet([]);
      setDataRet([]);
      setDatosIsrl([]);
      setDataIsrl([]);
    } else if (e.target.name === "codcuenta") {
      txtNumCuentaBanco.current.value = "";
      txtBanco.current.value = "";
    }
  };
  const crearreversar = () => {
    let datosorden = [];
    let datoscue = [];
    datosorden.push({
      idcompro: txtIdCompromiso.current.value,
      referencia: txtReferencia.current.value,
      observ: txtObservacion.current.value,
      montoorden: totalCausar,
      idcuentaban:
        txtCodCuenta.current.value === "" ? "0" : txtCodCuenta.current.value,
      tipopag: 0,
      fechareverso:
        props.operacion === 2 ? txtFechaReverso.current.value : null,
    });

    var datacue = [...data];
    for (let i = 0; i < datacue.length; i++) {
      datoscue.push({
        m_nIdCta: datacue[i].idcuenta,
        m_cAux: datacue[i].auxiliar,
        m_nMonto: datacue[i].monto,
        m_nMontoCausado: datacue[i].montocausado,
        m_nMontoAjustado: datacue[i].montoajustado,
        m_nMontoCausar: datacue[i].montocausar,
        m_nIdCatPro: datacue[i].idcat,
        m_nIdPuc: datacue[i].idpuc,
        m_nIdMov: datacue[i].idmovimiento,
        m_nIdMovc: data[i].idmovimiento,
      });
    }
    setBody({
      operacion: props.operacion,
      idordenp: txtCodigo.current.value,
      idorden: idOrden,
      norden: props.norden,
      idefi: idefiscal,
      idusuario: idusuario,
      tipo: tipoComp,
      fecha: txtFechaOP.current.value,
      espiritu: espiritu,
      datosordenp: datosorden,
      datoscuenta: datoscue,
      datosfactu: dataFac,
      datosrete: dataRet,
      datosreteislr: dataIsrl,
    });
    let msg = "";
    setDesde(0);
    if (props.operacion === 1) {
      msg = "Esta Seguro de Registrar estos Datos?.";
    } else if (props.operacion === 2) {
      msg = "Esta Seguro de Reversar esta Orden de Pago?.";
    } else if (props.operacion === 3) {
      msg = "Esta Seguro de Eliminar esta Orden de Pago?.";
    }
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: msg,
      icono: "confirmacion",
    });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código de la Orden de Pago no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtIdCompromiso.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del compromiso no puede estar en blanco.",
        icono: "informacion",
      });
      sigue = false;
      txtIdCompromiso.current.focus();
    } else if (txtFechaOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (
      new Date(txtFechaOP.current.value).getFullYear() !== anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (txtIdprov.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del provedor debe ser valido",
        icono: "informacion",
      });
      sigue = false;
      txtIdCompromiso.current.focus();
    } else if (
      (txtNumCuentaBanco.current.value.trim() === "" ||
        txtBanco.current.value.trim() === "") &&
      props.norden &&
      espiritu !== 4
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del banco debe ser valido",
        icono: "informacion",
      });
      setTabs({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      txtCodCuenta.current.focus();
    } else if (valida !== 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No existen cuentas presupuestaria para el compromiso",
        icono: "informacion",
      });
      sigue = false;
    } else if (
      moment.utc(fechaRef).format("YYYY-MM-DD") > txtFechaOP.current.value
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha de la Orden de Pago no Puede ser Anterior a la Fecha del Compromiso",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (
      props.operacion === 2 &&
      txtFechaReverso.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha de Reverso no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if (
      props.operacion === 2 &&
      txtFechaOP.current.value > txtFechaReverso.current.value
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha de Reverso no Puede ser Anterior a la de la Orden de Pago",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if (parseFloat(totalFactura) !== parseFloat(totalCausar) && dataFac.length > 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Total de las Facturas debe ser igual\nal Monto de la Orden",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    }
    if (sigue) {
      if (props.operacion === 1) {
        if (ultimo + 1 !== parseInt(txtCodigo.current.value)) {
          setDesde(4);
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto:
              "El Código de la Orden no corresponde al proximo número disponible, Desea Continuar?",
            icono: "confirmacion",
          });
        } else {
          crearreversar();
        }
      } else {
        crearreversar();
      }
    }
  };
  const ActualizarAsiento = () => {
    let body = {
      operacion: props.operacion,
      idordenp: txtCodigo.current.value,
      idorden: idOrden,
      norden: props.norden,
      fecord:
        props.operacion === 2
          ? txtFechaReverso.current.value
          : txtFechaOP.current.value,
      idefi: idefiscal,
      tipo: tipoComp,
    };
    let endpoint = `${op.conexion}/api/administracion/asientoordenpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setDesde(2);
            setMensajesino({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "Desea Imprimir En este Momento la Orden de Pago?",
              icono: "confirmacion",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Orden de Pago " +
                txtCodigo.current.value +
                " Reversada Correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Orden de Pago " +
                txtCodigo.current.value +
                " Eliminada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (error.response.data.message === "Asiento no generado.") {
            mensaje = "Asiento no generado.";
            setActivate(false);
            if (props.operacion === 1) {
              setDesde(2);
              setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: "Desea Imprimir En este Momento la Orden de Pago?",
                icono: "confirmacion",
              });
            } else if (props.operacion === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "Orden de Pago " +
                  txtCodigo.current.value +
                  " Reversada Correctamente",
                icono: "exito",
              });
            } else if (props.operacion === 3) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "Orden de Pago " +
                  txtCodigo.current.value +
                  " Eliminada Correctamente",
                icono: "exito",
              });
            }
            return;
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/crearreversarordenpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          ActualizarAsiento();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setDatospre([]);
    setDatosFac([]);
    setDatosRet([]);
    setDatosIsrl([]);
    setActivate(false);
    setValida(0);
    setData([]);
    setDataFac([]);
    setDataRet([]);
    setDataIsrl([]);
    setTipoComp(null);
    setTipo(null);
    setBody(null);
    setHabicod(true);
    setHabicat(true);
    setHabicatb(true);
    setHabiref(true);
    setHabiFecha(false);
    setHabiConcep(false);
    setCambioDatos(false);
    setModifi(false);
    setProce(false);
    setModifi1(false);
    setProce1(false);
    setProce2(false);
    setDesde(0);
    setItemSelect(-1);
  };
  const procesarCambioFechaReverso = () => {
    let body = {
      idorden: idOrden,
      dfecha: fechaRev,
      idefi: idefiscal,
      idusu: idusuario,
      fechasis: fechaSistema,
      dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
      dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
    };
    let endpoint = `${op.conexion}/api/administracion/modificarfechareversoordenpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtFechaReverso.current.value = moment.utc(fechaRev).format("YYYY-MM-DD");
          setFecha(fechaRev);
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const imprimirOrdenPago = () => {
    var reporte = "";
    if (canReten >= 30) {
      reporte = "ForOrdenPagoRetAB";

      /*       if (
              espiritu === 9 ||
              espiritu === 12 ||
              espiritu === 1 ||
              espiritu === 15
            ) {
              reporte = "ForOrdenPagoRetAraure";
            } else if (espiritu === 13 || espiritu === 14) {
              reporte = "ForOrdenPagoRetAB";
            } else {
              reporte = "ForOrdenPagoRet";
            } */
    } else {

      reporte = "ForOrdenPagoPreAB";


      /*  if (
         espiritu === 9 ||
         espiritu === 12 ||
         espiritu === 1 ||
         espiritu === 15
       ) {
         reporte = "ForOrdenPagoPreAraure";
       } else if (espiritu === 13 || espiritu === 14) {
         reporte = "ForOrdenPagoPreAB";
       } else {
         reporte = "ForOrdenPago";
       } */
    }
    var sql = "";
    var sql2 = "1";
    var sql3 = "";
    if (tipoComp === 7) {
      sql2 = "0";
    }
    var monto = formatMoneda(
      totalCausar.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    var sql1 = numeroaLetra(monto.trim().replace(/\./g, "")) + " Bs.";
    sql =
      "ORD.IdOrdenPago  in (" +
      idOrden +
      ") AND CPG.IDEFISCAL = " +
      idefiscal +
      " AND MXC.IDEFISCAL = " +
      idefiscal +
      " AND ORD.IDEFISCAL = " +
      idefiscal;
    sql3 =
      "CPG.referencia = " +
      (props.norden
        ? tipoComp === 5
          ? "ORC.idordencompra"
          : "ORC.idordenservicio"
        : "ORC.idordencompra") +
      " AND ORC.IDEFISCAL = " +
      idefiscal;

    window.open(
      op.reportes +
      "/administracionTesoreria?" +
      "reporte=" +
      reporte +
      "&ID=" +
      sql +
      "&ENLETRAS=" +
      sql1 +
      "&DESCRIPTOR=" +
      sql2 +
      "&CONDICION=" +
      sql3 +
      "&USUARIO=" +
      liquidador.trim() +
      "&VIENE=" +
      espiritu,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };
  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      procesarCambioFechaReverso();
    } else if (desde === 2) {
      imprimirOrdenPago();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "Orden de Pago " +
          txtCodigo.current.value +
          " Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      imprimirOrdenPago();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Orden de Pago Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      crearreversar();
    } else {
      Actualizar();
    }
  };
  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 2) {
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Orden Pago Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      txtCodigo.current.focus();
    }
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    if (data && data.length > 0) {
      setValida(1);
      if (props.operacion === 1) {
      } else {
      }
      let total = 0.0;
      let totalcausar = 0.0;
      for (let i = 0; i < data.length; i++) {
        total = parseFloat(total) + parseFloat(data[i].monto);
        totalcausar = parseFloat(totalcausar) + parseFloat(data[i].montocausar);
      }
      setTotalCausar(
        Math.round(parseFloat(totalcausar) * Math.pow(10, 4)) / Math.pow(10, 4)
      );
      txtMontoCausar.current.value = formatMoneda(
        totalcausar.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      if (tipo === 7) {
        let totalpagar =
          Math.round(
            (parseFloat(totalcausar) - parseFloat(amortizacion)) *
            Math.pow(10, 4)
          ) / Math.pow(10, 4);
        txtTotalPagar.current.value = formatMoneda(
          totalpagar.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
      if (tipo === 12 || tipo === 23 || props.operacion === 4 || tipo === 24) {
      }
      setData(data);
    } else {
      setValida(0);
      setData();
    }
  };
  const BaseDatosFac = (data, index, ope, numfact) => {
    let totalF = 0.0;
    let totalB = 0.0;
    for (let i = 0; i < data.length; i++) {
      totalF = parseFloat(totalF) + parseFloat(data[i].total);
      totalB = parseFloat(totalB) + parseFloat(data[i].baseimponible);
    }
    totalF = Math.round(parseFloat(totalF) * Math.pow(10, 4)) / Math.pow(10, 4);
    totalB = Math.round(parseFloat(totalB) * Math.pow(10, 4)) / Math.pow(10, 4);
    setTotalFactura(totalF);
    setTotalBaseImpo(totalB);
    setDataFac(data);
    setItemSelect(index);
    if (ope === 2) {
      setDataRet(
        dataRet.filter((it) => it.numfactura !== data[index].numfactura)
      );
      setDatosRet(
        dataRet.filter((it) => it.numfactura !== data[index].numfactura)
      );
    } else if (ope === 3) {
      setDataRet(dataRet.filter((it) => it.numfactura !== numfact));
      setDatosRet(dataRet.filter((it) => it.numfactura !== numfact));
    } else {
      if (desde === 5) {
        if (index < 0) {
          setItemSelect(0);
        }
        setDatosRet(dataRet);
      } else {
        setDatosRet(dataRet);
      }
    }
    if (ope === 1 || ope === 3) {
      setItemSelect(index);
      setDatosFac(data);
    }
  };

  const BaseDatosRet = (data) => {
    let total = 0.0;
    let cont = 0;
    for (let i = 0; i < data.length; i++) {
      total = parseFloat(total) + parseFloat(data[i].totalrete);
      cont++;
    }
    setCanReten(cont);
    total = Math.round(parseFloat(total) * Math.pow(10, 4)) / Math.pow(10, 4);
    setTotalRetenido(total);
    setDataRet(data);
  };

  const BaseDatosIsrl = (data) => {
    setDataIsrl(data);
  };

  const catalogoCompromiso = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const catalogoBanco = (e) => {
    e.preventDefault();
    setMostrar(true);
  };

  const handleCancelarBanco = () => {
    setMostrar(false);
  };

  const handleCancelaCompromiso = () => {
    setMostrar4(false);
  };
  const seleccionarUnidadEjecutora = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcoordinacion > 0) {
            txtIdCoordinacion.current.value = response.data.idcoordinacion;
            txtNombreUnidad.current.value = response.data.nombre;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const seleccionarCompromiso = (id, desde) => {
    let nrorefe =
      txtReferencia.current.value === "" ||
        txtReferencia.current.value === "undefined"
        ? 0
        : parseInt(txtReferencia.current.value);
    let endpoint = `${op.conexion}/api/presupuesto/seleccionarcompromisoordenpago?idefi=${idefiscal}&operacion=${props.operacion}&&idcompro=${id}&espiritu=${espiritu}&nroreferencia=${nrorefe}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setTabs({
              tab1: "tab-pane fade show active",
              tab2: "tab-pane",
              tab3: "tab-pane",
              tab4: "tab-pane",
            });
            if (props.operacion === 1) {
              setHabiConcep(true);
              if (response.data[0].reversado === 1) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue reversado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (response.data[0].status === 1) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue causado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (response.data[0].status === 2) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue pagado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (response.data[0].ubicacion !== "42") {
                setMensaje({
                  mostrar: true,
                  titulo: "Informacion.",
                  texto: response.data[0].mensajeubi,
                  icono: "informacion",
                });
                setActivate(false);
                return;
              } else {
                txtFechaOP.current.focus();
              }
            } else {
            }
            setTipoComp(response.data[0].tipo);
            if (response.data[0].tipo === 5) {
              txtTipoCompromiso.current.value = "1";
            } else if (response.data[0].tipo === 7) {
              txtTipoCompromiso.current.value = "2";
            } else if (response.data[0].tipo === 11) {
              txtTipoCompromiso.current.value = "3";
            } else if (response.data[0].tipo === 12) {
              txtTipoCompromiso.current.value = "4";
            } else if (response.data[0].tipo === 13) {
              txtTipoCompromiso.current.value = "5";
            } else if (response.data[0].tipo === 23) {
              txtTipoCompromiso.current.value = "6";
            } else if (response.data[0].tipo === 24) {
              txtTipoCompromiso.current.value = "7";
            } else if (response.data[0].tipo === 25) {
              txtTipoCompromiso.current.value = "8";
            } else if (response.data[0].tipo === 26) {
              txtTipoCompromiso.current.value = "9";
            }
            setFechaRef(response.data[0].fecha);
            txtFechaCompromiso.current.value = moment.utc(
              response.data[0].fecha
            ).format("YYYY-MM-DD");
            txtIdCoordinacion.current.value = response.data[0].idcoordinacion;
            seleccionarUnidadEjecutora(response.data[0].idcoordinacion);
            if (response.data[0].tipo === 7) {
              if (props.operacion === 1) {
                if (desde === "0") {
                  txtReferencia.current.value = "";
                  setHabiref(false);
                } else {
                  setDatospre(response.data);
                }
              } else {
                setHabiref(true);
                seleccionarSolicitudPagoObra(
                  txtReferencia.current.value,
                  props.operacion
                );
              }
            } else {
              setHabiref(true);
              let sinref = false;
              if (
                response.data[0].tipo === 13 ||
                response.data[0].tipo === 23 ||
                response.data[0].tipo === 24
              ) {
                txtReferencia.current.value = response.data[0].referencia;
              }
              sinref =
                response.data[0].tipo === 13 ||
                  response.data[0].tipo === 23 ||
                  response.data[0].tipo === 24
                  ? true
                  : false;
              if (response.data[0].referencia > 0 && sinref === false) {
                if (response.data[0].tipo !== 7) {
                  txtReferencia.current.value = response.data[0].referencia;
                  txtIdprov.current.value = response.data[0].idproveedor;
                  seleccionarProveedor(response.data[0].idproveedor);
                  txtConcepto.current.value = response.data[0].concepto.trim();
                  txtObservacion.current.value =
                    response.data[0].observacion.trim();
                  setValida(1);
                }
              } else {
                txtConcepto.current.value = response.data[0].concepto.trim();
                txtObservacion.current.value =
                  response.data[0].observacion.trim();
                txtIdprov.current.value = response.data[0].idproveedor;
                seleccionarProveedor(response.data[0].idproveedor);
              }
              if (props.operacion === 1) {
                setDatospre(response.data);
                if (
                  sinref === true &&
                  txtReferencia.current.value.trim() !== ""
                ) {
                  if (response.data[0].tipo === 13) {
                    seleccionarRetencionesNomina(
                      response.data[0].referencia,
                      response.data[0].montocompromiso,
                      response.data[0].fecha
                    );
                  } else {
                    let datosFactu = [];
                    datosFactu.push({
                      idfacturaxorden: 0,
                      numoperacion: "0",
                      numfactura: txtIdCompromiso.current.value,
                      numcontrol: txtIdCompromiso.current.value,
                      fecfactura: response.data[0].fecha,
                      subtotal: response.data[0].montocompromiso,
                      otros: 0.0,
                      ajuste: 0.0,
                      exento: 0.0,
                      baseimponible: response.data[0].montocompromiso,
                      porceiva: 0.0,
                      total: response.data[0].montocompromiso,
                    });
                    setDatosFac(datosFactu);
                  }
                }
                setTotalCausar(response.data[0].montocompromiso);
                txtMontoCausar.current.value = formatMoneda(
                  response.data[0].montocompromiso
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                );
              } else if (props.operacion === 4) {
              } else {
              }
            }
          } else {
            txtIdCompromiso.current.value = "";
            txtIdCompromiso.current.focus;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtIdCompromiso.current.value = "";
        txtIdCompromiso.current.focus;
      });
  };
  const seleccionarSolicitudPagoObra = (id, ope) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/administracion/seleccionarspagoobra?idefi=${idefiscal}&operacion=${ope}&idcompro=${txtIdCompromiso.current.value}&referencia=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtIdprov.current.value = response.data[0].idproveedor;
            seleccionarProveedor(response.data[0].idproveedor);
            txtConcepto.current.value = response.data[0].concepto.trim();
            txtObservacion.current.value =
              response.data[0].observaciones.trim();
            setAmortizacion(response.data[0].amortizacion);
            txtAmortizacion.current.value = formatMoneda(
              response.data[0].amortizacion
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            if (ope === 1) {
              txtMontoCausar.current.value = formatMoneda(
                response.data[0].nmonacomprometer
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setDatospre(response.data);
              let totalpagar =
                parseFloat(response.data[0].nmonacomprometer) -
                parseFloat(response.data[0].amortizacion);
              txtTotalPagar.current.value = formatMoneda(
                totalpagar.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              seleccionarCompromiso(txtIdCompromiso.current.value, "1");
            } else {
              let totalpagar =
                Math.round(
                  (parseFloat(
                    txtMontoCausar.current.value
                      .replace(/\./g, "")
                      .replace(",", ".")
                  ) -
                    parseFloat(response.data[0].amortizacion)) *
                  Math.pow(10, 4)
                ) / Math.pow(10, 4);
              txtTotalPagar.current.value = formatMoneda(
                totalpagar.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
            }
          } else {
          }
        }
      })
      .catch(function (error) {
        txtReferencia.current.value = "";
        txtReferencia.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const seleccionarProveedor = (codigo) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            setReteIslr(response.data.retencionislr);
            if (
              parseInt(response.data.denominacioncomercial) === 9 ||
              parseInt(response.data.denominacioncomercial) === 7
            ) {
              setNatural(true);
            } else {
              setNatural(false);
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const handleAceptaBanco = (data) => {
    txtCodCuenta.current.value = data.idcuentabancaria;
    txtBanco.current.value = data.nombre;
    txtNumCuentaBanco.current.value = data.cuentabancaria;
    setMostrar(false);
  };
  const handleAceptaCompromiso = (idcompromiso) => {
    blanquearDatosCompromiso();
    txtIdCompromiso.current.value = idcompromiso;
    setMostrar4(false);
    seleccionarCompromiso(idcompromiso, "0");
  };

  const seleccionarBanco = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            if (response.data.status === 2) {
              txtCodCuenta.current.value = "";
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "¡La Cuenta Bancaria está inactiva!",
                icono: "error",
              });
            } else {
              txtBanco.current.value = response.data.nombre;
              txtNumCuentaBanco.current.value = response.data.cuentabancaria;
            }
          } else {
            txtCodCuenta.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡Cuenta Bancaria no Registrada!",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        txtCodCuenta.current.value = "";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡Cuenta Bancaria no Registrada!",
          icono: "error",
        });
      });
  };
  const seleccionarRetencionesOrdenPago = (id) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesordenpago?idefi=${idefiscal}&&idordenp=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let nFac = response.data[0].numfactura;
            let datosFactu = [];
            for (let i = 0; i < response.data.length; i++) {
              if (i === 0 || nFac !== response.data[i].numfactura) {
                datosFactu.push({
                  idfacturaxorden: response.data[i].idfacturaxorden,
                  numoperacion: response.data[i].codoperacion,
                  numfactura: response.data[i].numfactura,
                  numcontrol: response.data[i].numcontrol,
                  fecfactura: response.data[i].fecfactura,
                  subtotal: response.data[i].subtotal,
                  otros: response.data[i].otros,
                  ajuste: response.data[i].ajuste,
                  exento: response.data[i].exento,
                  baseimponible: response.data[i].baseimponible,
                  porceiva: response.data[i].porceiva,
                  total: response.data[i].total,
                });
              }
              nFac = response.data[i].numfactura;
            }
            setDataFac(response.data);
            setDatosFac(datosFactu);
            if (response.data[0].iddetalle !== null) {
              setDataRet(response.data);
              setDatosRet(response.data);
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SeleccionarRetencionesIsrlOrdenPago = (id) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionisrlordenpago?idefi=${idefiscal}&&idordenp=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setDataIsrl(response.data);
            setDatosIsrl(response.data);
          } else {
            setDataIsrl([]);
            setDatosIsrl([]);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleCompromiso = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCompromiso(event.target.value, "0");
      }
    }
  };
  const handleBanco = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarBanco(event.target.value);
      }
    }
  };
  const seleccionarRetencionesNomina = (id, montoc, fec) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesnomina?idefi=${idefiscal}&referencia=${id}&fechasis=${fechaSistema}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let datosFactu = [];
            datosFactu.push({
              idfacturaxorden: 0,
              numoperacion: "0",
              numfactura: txtIdCompromiso.current.value,
              numcontrol: txtIdCompromiso.current.value,
              fecfactura: fec,
              subtotal: montoc,
              otros: 0.0,
              ajuste: 0.0,
              exento: 0.0,
              baseimponible: montoc,
              porceiva: 0.0,
              total: montoc,
            });
            setDatosFac(datosFactu);
            let ret = [...response.data];
            for (let i = 0; i < response.data.length; i++) {
              ret[i].iddetalle = "0";
              ret[i].numfactura = txtIdCompromiso.current.value;
            }
            setDataRet(ret);
            setDatosRet(ret);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const seleccionaUltimoId = () => {
    let campos =
      (props.norden ? "numordenpago" : "idordenpago") + " AS ultimoid";
    let nomtab = "ordenpago";
    let condi =
      "idefiscal=" +
      idefiscal +
      (props.norden ? " AND (tipo = 0 OR tipo = 1)" : "");
    let orden =
      (props.norden ? "numordenpago" : "idordenpago") + " DESC LIMIT 1";
    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setUltimo(parseInt(response.data[0].ultimoid));
            setHabicod(false);
            txtCodigo.current.value = parseInt(response.data[0].ultimoid) + 1;
          } else {
            setUltimo(0);
            setHabicod(false);
            txtCodigo.current.value = 1;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarIdOrden = () => {
    let campos = "idordenpago";
    let nomtab = "ordenpago";
    let condi = "idefiscal=" + idefiscal;
    let orden = "idordenpago DESC LIMIT 1";

    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setIdOrden(parseInt(response.data[0].idordenpago) + 1);
          } else {
            setIdOrden(parseInt(1));
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idcommpromiso") {
          txtTipoCompromiso.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const eliminarRetencionesIslr = () => {
    setDatosIsrl([]);
    setDataIsrl([]);
  };
  const cambiarConcepto = () => {
    setDesde(0);
    setMostrarUsuario(true);
  };
  const editarFactura = () => {
    if (props.ordenp.statusorden === 0) {
      setDesde(5);
      setMostrarUsuario(true);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto:
          "No se pueden modificar las Retenciones ya que la orden de pago posee egreso realizado",
        icono: "error",
      });
    }
  };
  const cambiarFechaReverso = () => {
    setDesde(1);
    setMostrarUsuario(true);
  };
  const validarModificarFechaReverso = () => {
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Está Seguro de Cambiar la Fecha de Reverso de la Orden de Pago?",
      icono: "confirmacion",
    });
  };
  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    if (desde === 0) {
      setModifi(false);
      setProce(true);
      setModifi1(false);
      setProce1(false);
      setProce2(false);
      setHabiFecha(false);
      setHabiConcep(false);
      setHabicod(false);
    } else if (desde === 1) {
      setLlamado(3);
      setFecha(txtFechaReverso.current.value);
      setCambiarDatos(true);
    } else if (desde === 5) {
      setModifi1(false);
      setProce1(true);
      setModifi(false);
      setProce(false);
      setProce2(true);
    }
  };
  const aceptaCambioDatos = (
    // codigo,
    fecha,
    llamado
  ) => {
    setCambiarDatos(false);
    setFechaRev(fecha);
    if (llamado === 3) {
      validarModificarFechaReverso();
    }
  };

  const handleReferencia = (e) => {
    if (e.which === 13 || typeof e.which === "undefined") {
      txtBanco.current.focus();
      if (e.target.value !== "") {
        if (tipoComp === 7) {
          seleccionarSolicitudPagoObra(e.target.value, props.operacion);
        }
      }
    }
  };

  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/administracion/modificarconceptoordenpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setModifi(true);
          setProce(false);
          setHabiConcep(true);
          setHabiFecha(true);
          setHabicod(true);
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarModificarConcepto = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código de la Orden de Pago no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtFechaOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (
      new Date(txtFechaOP.current.value).getFullYear() !== anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (
      fechaRef !== null &&
      tipo !== 13 &&
      moment.utc(fechaRef).format("YYYY-MM-DD") > txtFechaOP.current.value
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha del Compromiso no Puede ser Anterior a la Fecha de la Referecncia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    }

    if (sigue) {
      let body = {
        idordenpnue: txtCodigo.current.value,
        idorden: idOrden,
        norden: props.norden,
        observ: txtObservacionOP.current.value,
        dfecha: txtFechaOP.current.value,
        idefi: idefiscal,
        idusu: idusuario,
        fechasis: fechaSistema,
        dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
        dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
        idcuentaban:
          txtCodCuenta.current.value === "" ? "0" : txtCodCuenta.current.value,
      };
      procesarCambio(body);
    }
  };
  const cancelar = () => {
    if (cambioDatos) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancelar();
    } else {
      blanquear();
      props.onHideCancelar();
    }
  };
  const onTabs = (op) => (e) => {
    e.preventDefault();
    if (op === 1) {
      setTabs({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 2) {
      setTabs({
        tab2: "tab-pane fade show active",
        tab1: "tab-pane",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 3) {
      setTabs({
        tab3: "tab-pane fade show active",
        tab1: "tab-pane",
        tab2: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 4) {
      setTabs({
        tab4: "tab-pane fade show active",
        tab1: "tab-pane",
        tab3: "tab-pane",
        tab2: "tab-pane",
      });
    }
  };
  const validarModificarRetenciones = (e) => {
    e.preventDefault();
    var sigue = true;
    if (parseFloat(totalFactura) !== parseFloat(totalCausar)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Total de las Facturas debe ser igual\nal Monto de la Orden",
        icono: "informacion",
      });
      sigue = false;
      //txtFechaOP.current.focus();
    }
    if (sigue) {
      modificarRetenciones();
    }
  };

  const modificarRetenciones = () => {
    let body = {
      operacion: props.operacion,
      idorden: idOrden,
      idefi: idefiscal,
      montoordenpago: totalCausar,
      tipo: tipoComp,
      datosfactu: dataFac,
      datosrete: dataRet,
      datosreteislr: dataIsrl,
    };
    let endpoint = `${op.conexion}/api/administracion/guardarfacturasyretenciones`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Las Retenciones se Realizaron con Exito",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  console.log(props.operacion)
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {

        setOperacion(props.operacion);
        setModifi(false);
        setModifi1(false);
        setTabs({
          tab1: "tab-pane fade show active",
          tab2: "tab-pane",
          tab3: "tab-pane",
          tab4: "tab-pane",
        });
        if (props.operacion !== 1) {
          if (
            props.operacion === 4 ||
            props.operacion === 3 ||
            props.operacion === 2
          ) {
            setHabicod(true);
          } else {
            setHabicod(false);
          }
          if (props.operacion === 4 && props.ordenp.reversado === 0) {
            setModifi(true);
            setModifi1(true);
          }
          setHabiFecha(true);
          setHabiConcep(true);
          txtCodigo.current.value = props.ordenp.idorden;
          setIdOrden(props.ordenp.idordenpago);
          txtFechaOP.current.value = moment.utc(props.ordenp.fechaorden).format(
            "YYYY-MM-DD"
          );
          txtObservacionOP.current.value = props.ordenp.observacionorden;
          txtCodCuenta.current.value = props.ordenp.idcuentabancaria;
          if (props.ordenp.idcuentabancaria > 0) {
            seleccionarBanco(props.ordenp.idcuentabancaria);
          }
          txtIdCompromiso.current.value = props.ordenp.idcompromiso;
          txtReferencia.current.value = props.ordenp.referencia;
          seleccionarCompromiso(props.ordenp.idcompromiso, "0");
          var cuen = [...props.cuentas];
          for (let i = 0; i < cuen.length; i++) {
            cuen[i].montocausar = parseFloat(props.cuentas[i].montocausado);
          }
          setDatospre(cuen);
          seleccionarRetencionesOrdenPago(props.ordenp.idordenpago);
          SeleccionarRetencionesIsrlOrdenPago(props.ordenp.idordenpago);
        } else {
          seleccionaUltimoId();
          seleccionarIdOrden();
          setHabicatb(false);
          setHabicat(false);
          setHabiConcep(false);
          setHabiFecha(false);
          setTotalFactura(0.0);
          txtObservacion.current.value = "";
          txtFechaOP.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {props.titulo +
            (props.operacion === 1 && ultimo
              ? ", Ultima procesada: " + ultimo
              : "")}
        </h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div
          className="col-12 m-0 p-0 px-2 pt-2 border-table rounded"
        >
          <input type="hidden" ref={txtNp} />
          <fieldset className="col-12 border-azul rounded m-0 p-0 p-2 d-flex flex-wrap justify-content-between gap-0 row-gap-2">
            <legend className="float-none m-0 w-auto">Datos</legend>
            {props.ordenp && props.ordenp.reversado > 0 && (
              <div className="col-12 input-group input-group-sm">
                <font color="red" size="1">
                  <h1 align="center">
                    <i>¡ La Orden de Pago está Reversada !</i>
                  </h1>
                </font>
              </div>
            )}
            <div className="col-3 col-lg-2 m-0 p-0">
              <Input
                label="Código:"
                onKeyUp={handleInputNumChange}
                disabled={habiCod}
                id="idordenpago"
                ref={txtCodigo}
              />
            </div>
            <div className="col-9 col-lg-3 p-0 pl-2 m-0">
              <SearchInput
                label="N° de Compromiso:"
                autocomplete="off"
                onKeyUp={handleCompromiso}
                onChange={onChange}
                disabled={habicat}
                name="idcompromiso"
                id="ref"
                disabledButton={habicatb}
                onClickButton={catalogoCompromiso}
                ref={txtIdCompromiso}
              />
            </div>
            <div className="col-12 col-lg-3 m-0 my-2 my-lg-0 p-0 px-lg-2">
              <Input
                label="Fecha Orden Pago:"
                type="date"
                disabled={habiFecha}
                defaultValue={
                  props.aprobaciones && props.aprobaciones.fecha !== ""
                    ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                id="inputDireccion"
                ref={txtFechaOP}
              />
            </div>
            {((props.ordenp && props.ordenp.reversado > 0) ||
              props.operacion === 2) && (
                <div className="col-3 m-0 p-0 ml-auto">
                  <Input
                    label="Fecha Reverso:"
                    type="date"
                    disabled={props.operacion === 2 ? false : true}
                    defaultValue={
                      props.ordenp &&
                        props.ordenp.fechareverso !== "" &&
                        props.ordenp.fechareverso !== null
                        ? moment.utc(props.ordenp.fechareverso).format("YYYY-MM-DD")
                        : moment.utc(fechaSistema).format("YYYY-MM-DD")
                    }
                    id="inputDireccion"
                    ref={txtFechaReverso}
                  />
                </div>
              )}


            <div className="input-group input-group-sm col-md-12 mx-auto px-0 mt-2 mb-2" >

              <span className="input-group-text m-0 p-0 px-2 fw-bolder text-uppercase">
                Observación Orden Pago:
              </span>

              <input
                autoComplete="off"
                name="observacion"
                onChange={onChange}
                disabled={!habiConcep}
                defaultValue={
                  props.aprobaciones
                    ? props.aprobaciones.observaciones.trim()
                    : ""
                }
                placeholder="Descripción"
                id="inputDireccion"
                ref={txtObservacionOP}
                className="form-control"
              />

              {modifi === true && (
                <WarningButton
                  icon="fa-edit m-0"
                  onClick={cambiarConcepto}
                ></WarningButton>
              )}
              {proce === true && (
                <SuccessButton onClick={validarModificarConcepto}>
                  Procesar
                </SuccessButton>
              )}
            </div>





            <div className="col-12 col-lg-4 m-0  p-0">
              <Select
                label="Tipo de Compromisos:"
                onChange={onChange}
                name="tipo"
                disabled={true}
                ref={txtTipoCompromiso}
                options={[
                  { value: "", label: "--Seleccione--" },
                  { value: "1", label: "ORDEN DE COMPRA" },
                  { value: "2", label: "PAGO DE OBRAS/SERVICIOS" },
                  { value: "3", label: "ORDEN DE SERVICIO" },
                  { value: "4", label: "PAGO DIRECTO" },
                  { value: "5", label: "PAGO DE NOMINA" },
                  { value: "6", label: "FONDO EN AVANCE" },
                  { value: "7", label: "FONDO EN ANTICIPO" },
                  { value: "9", label: "ORDEN DE DONACIÓN" },
                ]}
              />
            </div>
            <div className="col-6 col-lg-4 p-0 pr-2 pr-lg-0 px-lg-2 m-0 ">
              <Input
                label="Fecha de Compromiso:"
                type="date"
                disabled={true}
                id="inputDireccion"
                ref={txtFechaCompromiso}
              />
            </div>
            <div className="col-6 col-lg-4 m-0  p-0">
              <Input
                label="N° de Referencia:"
                disabled={habibref}
                autocomplete="off"
                onChange={onChange}
                name="referencia"
                id="inputDireccion"
                onKeyUp={handleReferencia}
                ref={txtReferencia}
              />
            </div>
          </fieldset>

          <fieldset className="col-12 rounded m-0 mt-2 p-2">
            <ul className="nav d-flex flex-wrap gap-1 align-items-center" id="ex-with-icons" role="tablist">

              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(1)}
                  className="nav-link active bg-blue-100 text-light rounded h-100"
                  id="tab1"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div1"
                  role="tab"
                  aria-controls="div1"
                  aria-selected="true"
                >
                  Detalles
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(2)}
                  className="nav-link bg-blue-200 text-light rounded"
                  id="tab2"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div2"
                  role="tab"
                  aria-controls="div2"
                  aria-selected="false"
                >
                  Codificación
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(3)}
                  className="nav-link bg-blue-300 text-light rounded"
                  id="tab3"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div3"
                  role="tab"
                  aria-controls="div3"
                  aria-selected="false"
                >
                  Retención
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(4)}
                  className="nav-link bg-blue-400 text-light rounded"
                  id="tab4"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div4"
                  role="tab"
                  aria-controls="div4"
                  aria-selected="false"
                >
                  Retención I.S.L.R
                </a>
              </li>
            </ul>
            <div className="tab-content mt-1 px-0" id="myTabContent">
              <div
                className={tabs.tab1}
                id="div1"
                role="tabpanel"
                aria-labelledby="tab1"
              >
                <div className="col-12 m-0 p-0 d-flex flex-wrap justify-content-between">
                  <div className="col-12 col-lg-6 px-2">
                    <fieldset className="col-12 border-azul rounded m-0 p-2 d-flex flex-wrap">
                      <legend className="float-none m-0 w-auto fw-bold fs-6">
                        Beneficiario
                      </legend>
                      <div className="col-6 m-0 p-0">
                        <SearchInput
                          label="Código:"
                          disabled={true}
                          name="observacion"
                          id="inputDireccion"
                          disabledButton={true}
                          ref={txtIdprov}
                        />
                      </div>
                      <div className="col-6 m-0 p-0 pl-2">
                        <Input
                          label="RIF:"
                          disabled={true}
                          name="observacion"
                          id="inputDireccion"
                          ref={txtCedurifprov}
                        />
                      </div>
                      <div className="col-12 p-0 m-0 mt-2">
                        <Input
                          label="Razón Social:"
                          disabled={true}
                          name="observacion"
                          defaultValue={
                            props.aprobaciones
                              ? props.aprobaciones.idaprobaciones.trim()
                              : ""
                          }
                          id="inputDireccion"
                          ref={txtNombreprov}
                        />
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-12 col-lg-6 px-2">
                    <fieldset className="col-12 border-azul rounded p-2 m-0 mb-2 mb-lg-0 d-flex flex-wrap">
                      <legend className="float-none m-0 w-auto fw-bold fs-6">
                        Unidad Ejecutora
                      </legend>
                      <div className="col-12 m-0 p-0">
                        <SearchInput
                          label="Código:"
                          disabled={true}
                          name="observacion"
                          id="inputDireccion"
                          ref={txtIdCoordinacion}
                          disabledButton={true}
                        />
                      </div>
                      <div className="col-12 m-0 mt-2 p-0">
                        <Input
                          label="Descripción:"
                          disabled={true}
                          name="observacion"
                          id="inputDireccion"
                          ref={txtNombreUnidad}
                        />
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-12 d-flex flex-wrap px-2 mt-2">
                    <div className="col-12 m-0 mb-2 p-0">
                      <Textarea
                        label="Concepto/Detalle:"
                        disabled={true}
                        style={{ height: "70px" }}
                        name="observacion"
                        id="inputDireccion"
                        ref={txtConcepto}
                      />
                    </div>
                    <div className="col-12 m-0 mb-2 p-0">
                      <Input
                        label="Observaciones:"
                        disabled={true}
                        name="observacion"
                        id="inputDireccion"
                        ref={txtObservacion}
                      />
                    </div>
                    <div className="col-6 col-lg-3 m-0 mb-2 ml-auto p-0">
                      <Input
                        label="Monto de la Orden:"
                        disabled={true}
                        id="idcompromiso"
                        defaultValue={"0,00"}
                        ref={txtMontoCausar}
                      />
                    </div>
                  </div>
                  <div
                    className="col-3 m-0 p-0 mb-1 pr-0"
                    style={{ display: tipoComp === 7 ? "block" : "none" }}
                  >
                    <Input
                      label="Amortización Anticipo:"
                      disabled={true}
                      id="idcompromiso"
                      defaultValue={"0,00"}
                      ref={txtAmortizacion}
                    />
                  </div>

                  <div
                    className="col-3 mb-1 pr-0"
                    style={{ display: tipoComp === 7 ? "block" : "none" }}
                  >
                    <Input
                      label="Total a Pagar:"
                      disabled={true}
                      id="idcompromiso"
                      defaultValue={"0,00"}
                      ref={txtTotalPagar}
                    />
                  </div>

                  <div className="col-12 px-2">
                    <fieldset
                      className="col-12 border-azul rounded m-0 p-2 d-flex flex-wrap"
                      style={{
                        display:
                          props.norden && espiritu !== 15 ? "block" : "none",
                      }}
                    >
                      <legend className="float-none m-0 w-auto fw-bold fs-6">
                        Datos de la Cuenta Bancaria
                      </legend>
                      <div className="col-4 col-lg-2 m-0 p-0">
                        <SearchInput
                          label="Código:"
                          disabled={!habiConcep}
                          onKeyUp={handleBanco}
                          onChange={onChange}
                          autoComplete="off"
                          name="codcuenta"
                          id="inputDireccion"
                          ref={txtCodCuenta}
                          disabledButton={!habiConcep}
                          onClickButton={catalogoBanco}
                        />
                      </div>
                      <div className="col-8 col-lg-5 m-0 p-0 pl-2">
                        <Input
                          label="Banco:"
                          disabled={true}
                          name="observacion"
                          id="inputDireccion"
                          ref={txtBanco}
                        />
                      </div>
                      <div className="col-12 col-lg-5 m-0 mt-2 mt-lg-0 p-0 pl-lg-2">
                        <Input
                          label="N° de Cuenta:"
                          disabled={true}
                          name="observacion"
                          id="inputDireccion"
                          ref={txtNumCuentaBanco}
                        />
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <div
                className={tabs.tab2}
                id="div2"
                role="tabpanel"
                aria-labelledby="tab2"
              >
                <div className="col-12 p-0 m-0">
                  <TablaCodificacionOrdenPago
                    data={BaseDatos}
                    datarecords={datospre}
                    operacion={operacion}
                  />
                </div>
              </div>
              <div
                className={tabs.tab3}
                id="div3"
                role="tabpanel"
                aria-labelledby="tab3"
              >
                <fieldset className="col-12 rounded border-azul p-2 m-0">
                  <div className="col-sm-3 mb-1 px-0">
                    <div className="input-group input-group-sm m-0 w-100">
                      {proce2 === true && (
                        <WarningButton
                          icon="fa-edit m-0"
                          onClick={() => {
                            setDesde(0);
                            setProce1(false);
                            setMostrar6(true);
                          }}
                        >
                          Modificar Factura
                        </WarningButton>
                      )}
                    </div>
                  </div>
                  <div className="col-12 mb-1 px-0">
                    <div className="input-group input-group-sm m-0 w-100">
                      {modifi1 === true && (
                        <WarningButton
                          icon="fa-edit m-0"
                          onClick={editarFactura}
                        ></WarningButton>
                      )}
                      {proce1 === true && (
                        <SuccessButton onClick={validarModificarRetenciones}>
                          Procesar
                        </SuccessButton>
                      )}
                    </div>
                  </div>
                  <legend className="float-none m-0 w-auto fw-bold">
                    Datos de la(s) Factura(s)
                  </legend>
                  <TablaFacturas
                    data={BaseDatosFac}
                    datarecords={datosFac}
                    operacion={operacion}
                    tipocomp={tipoComp}
                    dataIsrl={dataIsrl}
                    montocausar={totalCausar}
                    nombreprov={
                      txtNombreprov.current ? txtNombreprov.current.value : ""
                    }
                    onHideEliminarRetIsrl={eliminarRetencionesIslr}
                    desde={desde}
                  />
                </fieldset>

                <fieldset className="col-12 rounded border-azul p-2 m-0">
                  <legend className="float-none m-0 w-auto fw-bold">
                    Datos de las Retenciones
                  </legend>

                  <TablaRetenOrdenPago
                    data={BaseDatosRet}
                    datarecords={datosRet}
                    operacion={operacion}
                    tipocomp={tipoComp}
                    itemselect={itemSelect}
                    facturasel={dataFac[itemSelect]}
                    natural={natural}
                    montoislr={reteIslr}
                    desde={desde}
                  />
                </fieldset>
              </div>
              <div
                className={tabs.tab4}
                id="div4"
                role="tabpanel"
                aria-labelledby="tab4"
              >
                <TablaRetenISLR
                  data={BaseDatosIsrl}
                  datarecords={datosIsrl}
                  operacion={operacion}
                  natural={natural}
                  montoislr={reteIslr}
                  retenido={totalRetenido}
                  totalbaseimpo={totalBaseImpo}
                  totalfactura={totalFactura}
                  desde={desde}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        <SuccessButton
          onClick={onChangeValidar}
          disabled={props.operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
          Cancelar
        </DangerButton>
        {props.ordenp && props.operacion !== 1 ? (
          <button
            type="button"
            onClick={imprimirOrdenPago}
            className="btn btn-sm btnInfo-azulGradiant rounded"
          >
            <i className="fas fa-print"></i> Imprimir
          </button>
        ) : (
          ""
        )}
        {props.ordenp && props.operacion === 4 && props.ordenp.reversado > 0 ? (
          <button
            type="button"
            onClick={cambiarFechaReverso}
            className="btn btn-sm btnWarning-azulGradiant rounded"
          >
            <i className="fas fa-edit"></i> Editar Fecha Reverso
          </button>
        ) : (
          ""
        )}
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
          setDesde(0);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={0}
      />
      <CambiodeDatos
        show={cambiarDatos}
        onHideCancela={() => {
          setCambiarDatos(false);
        }}
        onHideConfirmar={aceptaCambioDatos}
        llamado={llamado}
        codigo={txtCodigo.current ? txtCodigo.current.value : ""}
        fecha={fecha}
        fechad={txtFechaOP.current ? txtFechaOP.current.value : ""}
        validarfechad={true}
      />
      <CatalogoCompromisosUbicacion
        show={mostrar4}
        proce={0}
        ubicacion={42}
        reversado={0}
        status={0}
        idefiscal={idefiscal}
        onHideCancelar={handleCancelaCompromiso}
        onHideAceptarCompromiso={handleAceptaCompromiso}
      />
      <CatalogoCuentaBancaria
        show={mostrar}
        onHideCancelar={handleCancelarBanco}
        onHideAceptaCatalogo={handleAceptaBanco}
      />
      <ModalModificarFact
        show={mostrar6}
        onHideCancela={() => {
          setMostrar6(false);
          seleccionarRetencionesOrdenPago(props.ordenp.idordenpago);
          SeleccionarRetencionesIsrlOrdenPago(props.ordenp.idordenpago);
        }}
        data={datosFac}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
